/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const SweepConfigStatus = {
  Enabled: "enabled",
  Disabled: "disabled",
} as const;
export type SweepConfigStatus = ClosedEnum<typeof SweepConfigStatus>;

/** @internal */
export const SweepConfigStatus$inboundSchema: z.ZodNativeEnum<
  typeof SweepConfigStatus
> = z.nativeEnum(SweepConfigStatus);
/** @internal */
export const SweepConfigStatus$outboundSchema: z.ZodNativeEnum<
  typeof SweepConfigStatus
> = SweepConfigStatus$inboundSchema;
